import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Statistics } from '@/models/statistics.model';
import statisticsService from '@/services/statistics.service';

import { onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuizCharts',
  setup(__props) {

const data = ref<Statistics[]>([]);
const data2 = ref<Statistics[]>([]);

onMounted(async () => {
  const d = await statisticsService.getQuizzesStartedFinished();
  data.value = d;
  const d2 = await statisticsService.getQuizzesPerDay();
  data2.value = d2;
});

return (_ctx: any,_cache: any) => {
  const _component_v_frappe_chart = _resolveComponent("v-frappe-chart")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Quiz Of The Day interaction", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("p", null, " This shows the amount of quizzes of the day over the last 30 days where people \"Started\" and \"Finished\" the quiz. ", -1)),
      _createVNode(_component_v_frappe_chart, {
        type: "bar",
        labels: data.value.map((d) => d.label),
        data: [
        {
          name: data.value[0]?.stackedValues[0].label || '',
          values: data.value.map((d) => d.stackedValues[0].value),
        },
        {
          name: data.value[0]?.stackedValues[1].label || '',
          values: data.value.map((d) => d.stackedValues[1].value),
        },

        {
          name: data.value[0]?.stackedValues[2].label || '',
          values: data.value.map((d) => d.stackedValues[2].value),
        },
      ],
        height: 480,
        colors: ['red', 'orange', '#ff570a']
      }, null, 8, ["labels", "data"]),
      _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Presented, Opened, and Completed quizzes", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", null, " This shows the amount of quizzes of the day over the last 30 days where people were \"Presented\" with, \"Watched\" and \"Completed\" their quiz. ", -1)),
      _createVNode(_component_v_frappe_chart, {
        type: "line",
        labels: data2.value.map((d) => d.label),
        data: [
        {
          name: data2.value[0]?.stackedValues[0].label || '',
          values: data2.value.map((d) => d.stackedValues[0].value),
        },
        {
          name: data2.value[0]?.stackedValues[1].label || '',
          values: data2.value.map((d) => d.stackedValues[1].value),
        },

        {
          name: data2.value[0]?.stackedValues[2].label || '',
          values: data2.value.map((d) => d.stackedValues[2].value),
        },
      ],
        height: 480,
        colors: ['red', 'green', 'blue']
      }, null, 8, ["labels", "data"])
    ]),
    _: 1
  }))
}
}

})